import { Route, createPageRoute, AppId } from '@lumapps/router';

const workflowsRoute: Route = createPageRoute({
    slug: 'workflows',
    appId: AppId.backOffice,
});

export { workflowsRoute };
